import { ChevronLeft } from 'lucide-react';
import { admin, palette, radii, typography } from '../../../styles/tokens';

interface PlaceholderItemProps {
  itemKey: string;
  title: string;
  onBack: () => void;
}

export default function PlaceholderItem({ itemKey, title, onBack }: PlaceholderItemProps) {
  return (
    <div style={{ maxWidth: 720, margin: '0 auto', padding: '8px 4px 0' }}>
      <button
        type="button"
        onClick={onBack}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 4,
          padding: '6px 8px 6px 4px',
          marginBottom: 16,
          background: 'transparent',
          border: 'none',
          color: admin.caption,
          fontSize: typography.size.caption,
          cursor: 'pointer',
          fontFamily: 'inherit',
        }}
      >
        <ChevronLeft size={16} />
        <span>Setup guide</span>
        <span style={{ color: palette.g400, margin: '0 4px' }}>›</span>
        <span style={{ color: admin.body }}>{title}</span>
      </button>

      <h1
        style={{
          margin: 0,
          fontSize: typography.size.title,
          fontWeight: typography.weight.bold,
          color: admin.header,
          letterSpacing: '-0.01em',
          marginBottom: 16,
        }}
      >
        {title}
      </h1>

      <div
        style={{
          background: palette.g50,
          border: `1px solid ${palette.g150}`,
          borderRadius: radii.md,
          padding: 24,
          fontSize: typography.size.body,
          color: admin.body,
          lineHeight: typography.lineHeight.relaxed,
        }}
      >
        Item form coming soon — this is item <strong>{itemKey}</strong>.
      </div>
    </div>
  );
}
